import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import PromoterList from "./PromoterList";
import { ModalPickerProps } from "../props";
import RemovablePromoter from "components/Removables/RemovablePromoter";
import CompanyNewModal from "company/new/App";
import { toCompanySmall } from "utilities/companyUtils";

const PromoterModalPicker = (props: ModalPickerProps<server.dto.CompanySmall>) => {
  const [displayNewCompanyModal, setDisplayNewCompanyModal] = React.useState(false);


  return <>
    {displayNewCompanyModal && <CompanyNewModal
      onClose={() => setDisplayNewCompanyModal(false)}
      onCreated={(c) => {
        props.onChange(toCompanySmall(c));
        setDisplayNewCompanyModal(false);
      }}
      defaults={{
        isPromoter: true
      }}
      disablePromoter
    />}
    <ModalPickerWithChooseButton
      onNewClicked={() => setDisplayNewCompanyModal(true)}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.promoter.plural}
      modalSize="mini"
      renderModalContent={(closeModal) => <PromoterList
        onItemSelected={(promoter) => {
          closeModal();
          props.onChange(promoter);
        }}
      />}
      renderRemovable={(props) => <RemovablePromoter {...props} />}

      {...props}
    />
  </>;
};

export default PromoterModalPicker;